<template>
  <div class="starter-kit-item">
    <div class="image image-responsive">
      <a @click="onPreview">
        <img :src="previewUrl ? previewUrl : `${serverUrl}/color-themes/svg/${styleRuleId}?id=${starterKit['preview-asset-ids'][0]}&${colors.map(c => `color=${c.hex.substr(1).toLowerCase()}`).join('&')}`" alt=""/>
      </a>

      <a class="bg hidden-phone" @click="onPreview"></a>

      <div class="popup hidden-phone" v-if="inline">
        <a class="btn primary medium" @click="onDownload('sketch')" v-show="isSketch">
          <i class="material-icons">file_download</i>
          Sketch
        </a>

        <a class="btn primary medium" v-show="isFigma">
          <i class="material-icons">open_in_new</i>
          Figma
        </a>

        <a class="btn primary medium" @click="onDownload('studio')" v-show="isStudio">
          <i class="material-icons">file_download</i>
          Studio
        </a>

        <a class="btn primary medium" @click="onDownload('xd')" v-show="isXd">
          <i class="material-icons">file_download</i>
          Xd
        </a>
      </div>
    </div>

    <div class="meta" @click="onPreview">
      <a class="info">
        <div class="title">{{starterKit.name}}</div>

        <div class="author">by {{starterKit['author-name']}}</div>
      </a>

      <div class="actions">
        <a class="item hoverable up" v-show="isScreen || isSketch">
          <img src="../../assets/sketch.png" alt=""/>

          <div class="popup">
            <div class="label hint">Supported Format</div>

            <div class="item">
              <img src="../../assets/sketch.png" alt=""/> Sketch
            </div>
          </div>
        </a>

        <a class="item hoverable up" v-show="isScreen || isFigma">
          <img src="../../assets/figma.png" alt=""/>

          <div class="popup">
            <div class="label hint">Supported Format</div>

            <div class="item">
              <img src="../../assets/figma.png" alt=""/> Figma
            </div>
          </div>
        </a>

        <a class="item hoverable up" v-show="isScreen || isStudio">
          <img src="../../assets/studio.png" alt=""/>

          <div class="popup">
            <div class="label hint">Supported Format</div>

            <div class="item">
              <img src="../../assets/studio.png" alt=""/> Studio
            </div>
          </div>
        </a>

        <a class="item hoverable up" v-show="isScreen || isXd">
          <img src="../../assets/xd.png" alt=""/>

          <div class="popup">
            <div class="label hint">Supported Format</div>

            <div class="item">
              <img src="../../assets/xd.png" alt=""/> Xd
            </div>
          </div>
        </a>

        <a class="item btn secondary medium hidden-phone">
          Preview
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { SERVER_URL } from '../../utils/config';

export default {
  name: 'starter-kit-item',
  props: {
    inline: Boolean,
    onPreview: Function,
    onDownload: Function,
    starterKit: Object,
    styleRuleId: String,
    colors: Array,
    isSketch: Boolean,
    isFigma: Boolean,
    previewUrl: String,
    isScreen: Boolean,
    isStudio: Boolean,
    isXd: Boolean,
  },
  data() {
    return {
      serverUrl: SERVER_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
  .starter-kit-item {
    padding: 10px;
    box-shadow: 0 12px 24px rgba(black, .15);
    background: $bg2;
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .image {
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    &:hover {
      .popup, .bg {
        opacity: 1;
        pointer-events: auto;
      }
    }

    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(#535353, .5);
      z-index: 1;
      transition: $transition;
      opacity: 0;
      pointer-events: none;
    }

    .popup {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      transform: translate(-50%, -50%);
      transition: $transition;
      opacity: 0;
      pointer-events: none;

      a {
        margin: 10px 0;
        min-width: 140px;
      }
    }
  }

  .meta {
    padding: 15px;

    @include media($notMobile) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    @include media($mobile) {
      text-align: center;
    }
  }

  .info {
    @include media($mobile) {
      margin-bottom: 15px;
    }
  }

  .title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 2px;
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      margin-left: 30px;

      @include media($mobile) {
        margin: 0 15px;
      }
    }
  }
</style>
